<script>
import deepLink from '@/mixins/deeplink.js'

export default {
  name: 'Confirmation',
  components: {},
  mixins: [deepLink()],
  props: {},
  computed: {},
  created() {},
  methods: {},
}
</script>

<template>
  <div :class="$style.container">

    <div :class="$style.container__content">
      <img
        class="container__logo"
        src="@assets/images/checkIcon.png"
        alt="check-icon">
      <h2>{{ $t('WIDGETS.COMMON.MESSAGE_SEND') }}</h2>
      <p>{{ $t('WIDGETS.COMMON.CONTACT_EMAIL') }}:</p>
      <p :class="$style.container__content__email"><span>{{ this.$route.query.userEmail }}</span>, {{ $t('WIDGETS.COMMON.AND_SUPPORT_SECTION_APP') }}.</p>
    </div>

    <BaseButton
      :class="$style.container__button"
      full
      @click="callDeepLink('goto=home')"
    >
      {{ $t('WIDGETS.COMMON.UNDERSTOOD') }}
    </BaseButton>
  </div>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
  min-height: 85vh;

  &__content {
    padding: 4rem;
    img {
      max-width: 7rem;
      max-height: 7rem;
      margin-bottom: 0.8rem;
    }

    h2 {
      margin-bottom: 1.5rem;
      color: $secondary-text;
    }
    p {
      @extend %typography-large;

      margin: 0;
      font-weight: 420;
      color: $secondary-text;

      span {
        font-weight: bold;
        color: $secondary-text;
      }
    }
    &__email {
      @extend %typography-large;
      margin: 0;
      font-weight: bold;
      color: $secondary-text;
    }
  }

  &__button {
    position: absolute;
    bottom: 2rem;
  }
}
</style>
